import { useCallback, useContext } from "react";

import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import {
	defaultLocalizerFactory,
	Localizable,
	LocalizableArgs,
	localizableFromLocalizationTreeMap,
	LocalizationTreeMap
} from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { de_DE } from "./resources/de_DE";

export { RESOURCE_KEYS } from "./keys";

export const DEFAULT_TRANSLATIONS: LocalizationTreeMap = {
	de: de_DE
};

export function localizableFromLocaleResources(key: string, args?: LocalizableArgs): Localizable {
	return localizableFromLocalizationTreeMap(key, DEFAULT_TRANSLATIONS, args);
}

/**
 * Localizer hook, which returns Localizer with applied default translations.
 */
export function useLocalizer(): (key: string, args?: LocalizableArgs) => string | undefined {
	const { localizer } = useContext(LocalizerContext);

	return useCallback((key, args) => localizer(localizableFromLocaleResources(key, args)), [localizer]);
}

export const defaultLocalizer = defaultLocalizerFactory({
	locale: { country: "DE", language: "de" },
	translationSource: DEFAULT_TRANSLATIONS
});
